<template>
  <div class="not-found">
    <h1>404</h1>
    <h2>Page Not Found</h2>
    <p>Sorry, the page you're looking for doesn't exist.</p>
    <p><strong>Requested path:</strong> {{ $route.fullPath }}</p>
    <router-link to="/" class="home-link">
      Return to Home
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  mounted() {
    console.log(`404 - Page not found: ${this.$route.fullPath}`)
    
    // Optional: Track 404 errors in analytics
    if (window.gtag) {
      window.gtag('event', 'page_not_found', {
        page_path: this.$route.fullPath
      })
    }
  }
}
</script>

<style scoped>
.not-found {
  text-align: center;
  padding: 4rem 2rem;
}

.not-found h1 {
  font-size: 6rem;
  margin-bottom: 0;
  color: #e74c3c;
}

.not-found h2 {
  margin-top: 0;
  color: #333;
}

.home-link {
  display: inline-block;
  margin-top: 2rem;
  padding: 0.75rem 1.5rem;
  background: #3498db;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  transition: background 0.3s;
}

.home-link:hover {
  background: #2980b9;
}
</style>